<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold" style="color: var(--pok-text)">
        {{ authenticated ? user.name : "Gast" }}
      </p>
      <small class="text-primary">ONLINE</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="authenticated && user.photo"
          key="onlineImg"
          :src="user.photo"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <img
          v-else
          key="onlineImg"
          src="../../../../assets/images/placeholder.png"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <!--IF LOGGED IN-->
          <router-link v-if="authenticated" to="/profil">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profil</span>
            </li>
          </router-link>

          <li
            v-if="authenticated"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>

          <!--IF NOT LOGGED IN-->
          <router-link v-if="!authenticated" to="/pages/login">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <feather-icon icon="LogInIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Login</span>
            </li>
          </router-link>

          <router-link v-if="!authenticated" to="/pages/register">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <feather-icon icon="UserPlusIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Registrieren</span>
            </li>
          </router-link>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white sm:hidden"
            @click="toggleTheme"
          >
            <feather-icon
              :icon="isDark ? 'SunIcon' : 'MoonIcon'"
              svgClasses="w-4 h-4"
            />
            <span class="ml-2">{{ isDark ? "Light Mode" : "Dark Mode" }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    /*  activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }, */
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
    isDark() {
      return this.$store.state.theme === "dark";
    },
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/logout",
    }),
    logout() {
      this.logoutAction();
      this.$router.replace({
        name: "page-login",
      });
    },
    toggleTheme() {
      var newTheme = this.$store.state.theme === "dark" ? "light" : "dark";
      this.$store.commit("UPDATE_THEME", newTheme);
      localStorage.setItem("theme", newTheme);
    },
  },
};
</script>
